/**
 * Created by alex.shmaltsuev on 2016-06-20.
 */
export default {
    GET_FAQ_LIST: 'GET_FAQ_LIST',
    FAQ_LIST:'FAQ_LIST'
}


// WEBPACK FOOTER //
// ./constants/faq.js